import produce from "immer";
import {
  // DistinctRecordActions,
  FETCH_DISTINCT_RECORD_FAILED,
  FETCH_DISTINCT_RECORD_PROGRESS,
  FETCH_DISTINCT_RECORD_SUCCESS,
} from "./distinctrecord.action";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "..";
import { initialDistinctRecordState } from "./distinctrecord.state";
import { DistinctRecordActions } from ".";

export const distinctRecordReducer = (
  state: IStoreState["distinctRecord"] = initialDistinctRecordState,
  action: DistinctRecordActions,
) => {
  switch (action.type) {
    case FETCH_DISTINCT_RECORD_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.InProgress;
        draftState.list.data = [];
        draftState.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_DISTINCT_RECORD_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.data = data;
        draftState.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_DISTINCT_RECORD_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.Failed;
      });
      return newState;
    }

    default: {
      return state;
    }
  }
};
